module.exports = __webpack_public_path__ + "img/CapReportes.03e50373.png";